import { memo, useCallback, useEffect, useRef } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { Element, Title } from 'src/components';
import { IContent } from 'src/interface';
import { ContentSapo } from 'src/modules/content/components/shared/ContentSapo';
import { ContentBody, ContentMeta } from '../..';
import { AdBanner } from 'src/modules/shared/components/ad';

import styles from './style.module.scss';
import { isLargeFontSize } from 'src/selectors/content';

interface IProps extends IContent {
    description: string;
    originalUrl?: string;
    bodys: any[];
    speechs: any[];
    showMoreButton?: boolean;
    isFetching?: boolean;
    isOpenContent?: boolean;
    adBottomContent?: any[];
    embedUrl?: string;
}

export default memo(function ContentMain(props: IProps) {
    const isLargeFont = useSelector(isLargeFontSize);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isLargeFont) {
            ref.current?.classList.add(styles['large-font']);
        } else {
            ref.current?.classList.remove(styles['large-font']);
        }
    }, [isLargeFont]);

    const renderAdsBottom = useCallback(() => {
        if (props.adBottomContent) {
            return props.adBottomContent?.map((id: string) => {
                return <AdBanner elId={id} key={id} />;
            });
        }
        return null;
    }, []);

    return (
        <Element renderAs="article" domRef={ref} className={cn(styles['content-main'])}>
            <Title
                renderAs="h1"
                className={cn(
                    'title',
                    'text-[24px] leading-[1.3] text-[var(--dark)] font-[800]',
                    'mb-[12px]',
                    'tracking-[-1%]',
                )}
            >
                {props.title}
            </Title>
            <ContentMeta content={props}  />
            <ContentSapo description={props.description} />
            <ContentBody
                isFetching={props.isFetching}
                isOpenContent={props.isOpenContent}
                publisherId={props.publisher?.id}
                {...props}
            />
            {renderAdsBottom()}
        </Element>
    );
});
